'use client';

import { useEffect, useLayoutEffect, useState } from 'react';
import { Product } from 'shared/types/product/Product';
import ProductDetailsAdapter from 'components/commercetools-ui/organisms/product/product-details/helpers/adapter';
import { DataSource, PersonalisationBalls } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';
import { useAccount } from 'frontastic/hooks';
import { DataLayerOnLoad } from 'helpers/dataLayerHelpers';
import useLocale from 'helpers/hooks/useLocale';
import { ImageProps } from 'frontastic/lib/image';
import { redirect, useRouter } from 'next/navigation';
import NotFound from 'components/commercetools-ui/organisms/not-found';
import { Variant } from 'shared/types/product';
import productDescription from '../../../../public/locales/en/product.json';
import { getCurrencyCookie } from 'helpers/utils/getCurrencyCookie';
import { productNameToMetaTitle } from 'helpers/utils/seoHelper';
export interface TrustBoxCss {
  width?: string;
  height?: string;
  fontcolour?: string;
  starColour?: string;
  horizontalAlignment?: string;
}
const ProductDetailsTastic = ({
  data,
  serverCurrency,
  seoStructureData,
}: TasticProps<DataSource<{ product: Product }>>) => {
  const trustBoxCss: TrustBoxCss = {
    width: data?.width,
    height: data?.height,
    fontcolour: data?.fontColour,
    starColour: data?.starColour,
    horizontalAlignment: data?.horizontalAlignment,
  };
  const personalisationBalls: PersonalisationBalls = {
    inkColoursLabel: data?.inkColoursLabel,
    inkColours: data?.inkColours,
    personalisationTextLabel: data?.personalisationTextLabel,
    personalisationLines: data?.personalisationLines,
    previewDesignLabel: data?.previewDesignLabel,
  };
  const product = data?.data?.dataSource?.product;
  const [variantForSeo, setVariantForSeo] = useState<Variant>(product?.variants?.[0] as Variant);

  const router = useRouter();
  if (!product) return null;
  const { getCountry, getCurrency, locale } = useLocale();
  const { account } = useAccount();
  const { _url: productUrl = '' } = product;

  useEffect(() => {
    const localeData = {
      country: getCountry(),
      currency: getCurrency(),
    };
    const currentUrl = document.location.origin;
    const dataLayer = new DataLayerOnLoad(currentUrl, 'product', localeData, account);
    dataLayer.setDataLayerOnLoad();
  }, []);
  // const normalizedProductUrl = productUrl?.replace(/^\/\//, '/');
  // useLayoutEffect(() => {
  //   if (normalizedProductUrl && !window.location.href.includes(normalizedProductUrl)) {
  //     router.replace(normalizedProductUrl);
  //   }
  // }, [normalizedProductUrl]);

  // useLayoutEffect(() => {
  //   if (productUrl && !window.location.href.includes(productUrl)) {
  //     router.replace(productUrl);
  //   }
  // }, [productUrl]);

  const { attributes, images, sku } = variantForSeo;
  const metaDescription = `${
    serverCurrency === 'GBP'
      ? productDescription?.descriptionSeo
          ?.replace(/'/g, '')
          ?.replace(/&/g, 'and')
          .replace('${productName}', productNameToMetaTitle(product?.name ?? ''))
      : productDescription?.descriptionSeo
          ?.replace(/'/g, '')
          ?.replace(/&/g, 'and')
          ?.replace('${productName}', productNameToMetaTitle(product?.name ?? ''))
          ?.replace('£100', '€116')
  }`;

  const standAlonePrice = attributes?.standalonePrice && JSON?.parse(attributes?.standalonePrice);
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product?.name,
    image: images?.[0],
    description: metaDescription,
    sku: sku,
    brand: {
      '@type': 'Brand',
      name: attributes?.brand,
    },
    offers: {
      '@type': 'Offer',
      url: productUrl,
      priceCurrency: standAlonePrice?.[locale?.replace('_', '-')]?.value?.currencyCode,
      price: (standAlonePrice?.[locale?.replace('_', '-')]?.value?.centAmount / 100).toFixed(2),
      availability: 'https://schema.org/InStock',
    },
  };

  return (
    <>
      <head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seoStructureData) }} />
      </head>

      <ProductDetailsAdapter
        product={product}
        productLogo={data?.productLogo?.media?.file}
        setVariantForSeo={setVariantForSeo}
        trustBoxCss={trustBoxCss}
        personalisationBalls={personalisationBalls}
      />
    </>
  );
};

export default ProductDetailsTastic;
